export const isStandalone = (): boolean => globalThis?.location?.search?.includes('standalone=true');
